import React from "react";
import Img from "gatsby-image"
import { Link } from "gatsby"

const Card = ({ project }) => {

  const cardBody = (
    <figure className="card">
      <Img fluid={project.image.fluid} />
      <figcaption className="card__caption">
        <h6>{project.title}</h6>
        <p>{project.description}</p>
        {project.date && (
          <p className="date">{project.date}</p>  
        )}
      </figcaption>
    </figure>
  );

  if(project.link !== "") {
    return (
      <div className="portfolio_item">
        <a href={project.link} target="blank">
          {cardBody}
        </a>
      </div>
    )
  } else {
  return(
      <div className="portfolio_item">
        {cardBody}
      </div>
    );
  }
}

export default Card;